import type { SidebarItem } from '@bv/router';

const sidebarItems: SidebarItem[] = [
  {
    title: 'Servers',
    route: { name: 'cc-servers-list' },
  },
  {
    title: 'Synchronization',
    route: { name: 'cc-sync-history' },
  },
];

export default sidebarItems;
